module.exports = __webpack_public_path__ + "img/af.9545855.svg";